import styles from "../../styles/PLMApp.module.css";
import { createPortal } from "react-dom";

import { STATUSES } from "../../data/constants";
import { getStatusStyle, getStatusLabel } from "../../utils/utils";
import { useState, useEffect, useRef } from "react";

export default function StatusToggle({
  currentStatus,
  onSelect,
  disabled = false,
  isAdmin,
}) {
  const [open, setOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const buttonRef = useRef();
  const ref_ = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (
        ref_.current &&
        !ref_.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleOpen = (e) => {
    e.stopPropagation();
    if (disabled) return;
    const rect = buttonRef.current.getBoundingClientRect();
    setDropdownPos({
      top: rect.top - 8,
      left: rect.left,
    });
    setOpen((p) => !p);
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        ref={buttonRef}
        type="button"
        disabled={disabled}
        className={`${styles.stepStatus} ${getStatusStyle(currentStatus)}`}
        onClick={handleOpen}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {getStatusLabel(currentStatus)}
      </button>

      {open &&
        !disabled &&
        createPortal(
          <div className={styles.app} style={{ all: "unset" }}>
            <div
              ref={ref_}
              className={styles.statusDropdown}
              style={{
                position: "fixed",
                top: "auto",
                bottom: `calc(100vh - ${dropdownPos.top}px)`,
                left: dropdownPos.left,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {STATUSES.map((s) => (
                <button
                  key={s.key}
                  className={styles.statusOption}
                  onClick={() => {
                    if (disabled) return;
                    onSelect?.(s.key);
                    setOpen(false);
                  }}
                >
                  <span
                    className={`${styles.stepStatus} ${s.style}`}
                    style={{
                      width: "auto",
                      padding: "2px 6px",
                      fontSize: "7px",
                    }}
                  >
                    {s.label}
                  </span>
                </button>
              ))}
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}
